/**
 * Utilities for displaying country names in analytics components.
 *
 * Country names from the backend (via GeoIpCountry) have lowercase "the"
 * prefixes for proper mid-sentence usage (e.g., "from the United States").
 * For table headers and titles, we capitalize the first letter.
 */

/**
 * Capitalizes the first letter of a country name for table/header display.
 *
 * Examples:
 *   "the United States" → "The United States"
 *   "Taiwan" → "Taiwan"
 *   "the Netherlands" → "The Netherlands"
 *
 * @param countryName - The country name from backend (via GeoIpCountry)
 * @returns The capitalized country name, or "Unknown" if input is invalid
 */
export function capitalizeCountryName(
  countryName: string | null | undefined,
): string {
  if (!countryName || countryName.trim() === '') {
    return 'Unknown';
  }

  const trimmed = countryName.trim();
  return trimmed.charAt(0).toUpperCase() + trimmed.slice(1);
}
